import { upsellProductSelectionSchema } from "@redotech/redo-conversion-core-common/upsell-page/upsell-page-db-validator";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const productInfoSchema_ = z.object({
  imageUrl: z.string().optional(),
  name: z.string(),
});
const productInfoSchema: z.ZodType<ProductInfo> = productInfoSchema_;
export interface ProductInfo extends z.infer<typeof productInfoSchema_> {}

export const getUpsellPages = {
  name: "getUpsellPages" as const,
  input: z.null(),
  output: z.array(
    z.object({
      _id: zExt.objectId(),
      name: z.string().optional(),
      createdAt: z.date(),
      active: z.boolean(),
      products: z.array(upsellProductSelectionSchema),
      // productId -> productInfo
      productInfo: z.map(z.string(), productInfoSchema),
      // collectionId -> collectionInfo
      collectionInfo: z.map(z.string(), z.object({ name: z.string() })),
    }),
  ),
};

export type GetUpsellPagesOutput = z.infer<typeof getUpsellPages.output>;
